module.exports = __webpack_public_path__ + "static/media/john-deere-logo.ad79e5dd.png";